export default __webpack_public_path__ + "assets/webapp.b11bb44af068ce2d079a9ccb9a80ee28.png";